
import { Link } from 'react-router-dom';
import { useUI }      from '../../context/UIContext';
import { useCurrency} from '../../context/CurrencyContext';
import { CURRENCIES } from '../../lib/currency';

export default function MobileNav() {
  const { mobileNavOpen, closeMobileNav, openEnquiry } = useUI();
  const { idx, cycle } = useCurrency();

  return (
    <>
      {mobileNavOpen && (
        <div className="animate-fade-in" onClick={closeMobileNav} style={{ position: 'fixed', inset: 0, background: 'rgba(26,26,26,0.5)', zIndex: 200 }} />
      )}
      <div className={mobileNavOpen ? 'animate-slide-left' : ''} style={{
        position: 'fixed', top: 0, left: 0, height: '100%', width: 280,
        background: '#fff', zIndex: 201,
        display: 'flex', flexDirection: 'column',
        transform: mobileNavOpen ? 'translateX(0)' : 'translateX(-100%)',
        transition: mobileNavOpen ? 'none' : 'transform 0.3s ease',
        boxShadow: '4px 0 24px rgba(0,0,0,0.12)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 24px', borderBottom: '1px solid var(--grey)' }}>
          <div>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 300, letterSpacing: '0.2em', textTransform: 'uppercase' }}>Aurora Luxury</div>
          </div>
          <button onClick={closeMobileNav} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--grey-dark)', padding: 4 }}>
            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"/></svg>
          </button>
        </div>

        <nav style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: '8px 0' }}>
          {[['Shop All', '/shop'], ['Brands', '/brands'], ['Journal', '/blogs'], ['The House', '/about'], ['My Wishlist', '/wishlist']].map(([label, href]) => (
            <Link key={label} to={href} onClick={closeMobileNav} style={{
              padding: '16px 24px', fontSize: 11, letterSpacing: '0.15em',
              textTransform: 'uppercase', fontWeight: 500, color: 'var(--dark)',
              borderBottom: '1px solid var(--grey-light)', transition: 'color 0.2s',
            }}
              onMouseEnter={e => e.target.style.color = 'var(--gold)'}
              onMouseLeave={e => e.target.style.color = 'var(--dark)'}>{label}</Link>
          ))}
          <button onClick={() => { closeMobileNav(); openEnquiry(); }} style={{
            padding: '16px 24px', fontSize: 11, letterSpacing: '0.15em',
            textTransform: 'uppercase', fontWeight: 500, color: 'var(--gold)',
            borderBottom: '1px solid var(--grey-light)', background: 'none', border: 'none',
            cursor: 'pointer', textAlign: 'left', fontFamily: 'var(--font-body)',
          }}>Request a Piece</button>
        </nav>

        <div style={{ padding: '20px 24px', borderTop: '1px solid var(--grey)' }}>
          <p style={{ fontSize: 10, letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--grey-mid)', marginBottom: 10 }}>Currency</p>
          <button onClick={cycle} style={{ fontSize: 13, fontWeight: 500, color: 'var(--dark)', background: 'none', border: 'none', cursor: 'pointer' }}>
            {CURRENCIES[idx].label}
          </button>
        </div>
      </div>
    </>
  );
}